import { useEffect } from 'react';

import { useSkillsActions } from './SkillsContext';

import { getSkills } from './restApi';

const SkillsLoader = ({ authenticatedUser }) => {
  const { initializeState, onResponse, onError } = useSkillsActions();

  useEffect(() => {
    initializeState(authenticatedUser);
  }, []);

  useEffect(() => {
    getSkills({
      onResponse,
      onError,
      pageNumber: 1,
    });
  }, []);

  return null;
};

export default SkillsLoader;
